import { STEPS } from '@perpay-web/fintech/constants/steps/verifyBankFormSelectSteps';
import { withReduxStepsReducer } from '@perpay-web/hooks/useReduxSteps';

export default withReduxStepsReducer(STEPS);
